import axios from './axiosConfig';
import authHeader from "./auth-header";
import { API_URL } from "utils/constants";

const getTrucks = (signal) => {
  return axios.get(API_URL + "trucks/", {
    headers: authHeader(),
    signal,
  });
};

const getUsersList = (signal) => {
  return axios.get(API_URL + "users_list/", {
    headers: authHeader(),
    signal,
  });
};

const getLocationsList = ({ location }) => {
  return axios.get(API_URL + `trucks/locations/${location}/`, {
    headers: authHeader(),
  });
};

const createTrucks = (data) => {
  return axios.post(
    API_URL + "trucks/create/",
    data,
    {
      headers: authHeader(),
    },
  );
};

const editTrucks = (data) => {
  return axios.put(
    API_URL + "trucks/update/",
    data,
    {
      headers: authHeader(),
    },
  );
};

const updateStatusAndLocation = ( data ) => {
  return axios.patch(
    API_URL + "trucks/status-location/update/",
    data,
    {
      headers: authHeader(),
    },
  );
};

const deleteTruck = ( data ) => {
  return axios.delete(
    API_URL + `trucks/${data.id}/`,
    {
      headers: authHeader(),
    },
  );
};

const trucksService = {
  getTrucks,
  getUsersList,
  getLocationsList,
  createTrucks,
  editTrucks,
  updateStatusAndLocation,
  deleteTruck
};

export default trucksService;
